<template>
  <div>
    <el-row type="flex" class="row-bg" justify="center">
      <h1>Reporte de Productividad por mes</h1>
    </el-row>
    <el-row :gutter="10" type="flex" class="row-bg" justify="start">
      <el-col :span="3">
        <YearsComponent @change="onYearChange" :disabled="loadingData" />
      </el-col>

      <el-col :span="3">
        <TypeTasks :disabled="loadingData" @type-change="onTypeChange" />
      </el-col>
      <el-col :span="3">
        <DirectionSelector
          :initialDirection="filters.Direction"
          @selection-change="OnDirectionSelected"
          :isDisabled="loadingData"
        />
      </el-col>
      <el-col :span="3">
        <DepartmentsComponent
          :initialDirection="filters.Direction"
          :initialDeparment="filters.Deparment"
          :DirecctionID="filters.Direction"
          fieldSize="mini"
          @selectionChange="OnDeparmentSelected"
          :isDisabled="loadingData"
        />
      </el-col>
      <el-col :span="3">
        <EmployeeSelector
          :DireccionParams="filters.Direction"
          :DeparmentParams="filters.Deparment"
          :CurrentEmployee="filters.Responsible"
          placeholder="Responsable"
          @selection-change="OnResponsibleSelected"
          :disabled="loadingData"
        />
      </el-col>
    </el-row>

    <el-row>
      <rabbey-table-3
        :border="true"
        :stripe="true"
        :actions="TaskActions"
        @rtable-push-action="handlePushAction"
        :loading="loadingData"
        :data="FilteredTasks"
        :columns="TaskColumns"
        show-summary
        sum-text="Tiempo Total"
        :summary-method="getSummaries"
        page_Size="500"
        :pageSizes="[500, 1000]"
      />
    </el-row>
  </div>
</template>

<script>
import { columns } from "@/columns/ProductiveHoursReportByMonths/ProductiveHoursReportByMonths";
import YearsComponent from "@/components/Global_System/YearsComponent";
import TypeTasks from "@/components/ProductivesHoursReport/TypeTasks";
import DirectionSelector from "@/components/Company/DirectionSelector";
import DepartmentsComponent from "@/components/Company/DepartmentsComponent";
import EmployeeSelector from "@/components/Company/EmployeeSelector";
const actualYear = new Date().getFullYear();

export default {
  name: "ProductiveHoursReportByMonth",
  components: {
    YearsComponent,
    TypeTasks,
    DirectionSelector,
    DepartmentsComponent,
    EmployeeSelector
  },
  data() {
    return {
      FilteredTasks: [],
      TaskColumns: columns(this),
      TaskActions: [],
      loadingData: false,
      filters: {
        Responsible: 0,
        Direction: 0,
        Deparment: 0,
        Year: actualYear,
        // Month: 0,
        Week: 0,
        Type: 0
      }
    };
  },
  mounted() {
    this.getTasksForReport();
  },
  methods: {
    async getTasksForReport() {
      // Fetch or compute tasks for the report
      this.loadingData = true;
      await this.$http
        .get("api/ReporteGestion/Get_Productive_Hours_Report_By_Month", {
          params: {
            ResponsableID: this.filters.Responsible,
            DirecctionID: this.filters.Direction,
            DeparmentId: this.filters.Deparment,
            Year: this.filters.Year,
            // Month: this.filters.Month,
            // WeekOnMothSelected: this.filters.Week,
            Type: this.filters.Type
          }
        })
        .then((response) => {
          this.FilteredTasks = response.data;
        })
        .catch((error) => {
          console.error("Error fetching tasks:", error);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    handlePushAction() {},
    getSummaries() {},
    async onYearChange(year) {
      // this.actualMonth = 1;
      // this.TabName = 1;
      this.filters.Year = year;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async onTypeChange(type) {
      // this.TabName = 1;
      this.filters.Type = type;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async OnDirectionSelected(val) {
      this.filters.Direction = val;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async OnDeparmentSelected(val) {
      this.filters.Deparment = val;
      await this.getTasksForReport();
    },
    async OnResponsibleSelected(val) {
      this.filters.Responsible = val;
      await this.getTasksForReport();
      // this.TabName = 1;
      // await this.KnowIfIsHisSupervisor(val);
      // await this.ReorderTasksMethod();
      // await this.GetRequestTasksData();
      //this.GetDataForReport();
    }
  }
};
</script>

<style lang="scss" scoped></style>
